import { inject, Injector } from '@angular/core';
import {
  combineLatest,
  filter,
  map,
  mergeMap,
  Observable,
  take,
  tap,
} from 'rxjs';
import { VerificationService } from './verification.service';
import {
  patchDomHandlerGetScrollableParents,
  SessionService,
} from '@everymatrix-base-components/utils';
import { createCustomElement } from '@angular/elements';
import { AppComponent } from '../app.component';

export function initializeApp(): Observable<unknown> {
  const sessionService = inject(SessionService);
  const verificationService = inject(VerificationService);
  const injector = inject(Injector);
  return sessionService.sessionData$.pipe(
    filter((data) => data !== null),
    take(1),
    mergeMap(() =>
      combineLatest({
        lookups: verificationService.getLookups(),
        domainLookups: verificationService
          .getDomainLookups()
          .pipe(map((d) => d.domains_mm)),
        columns: verificationService.getReportFilters(),
      }).pipe(
        take(1),
        tap((results) => verificationService.setInitData(results))
      )
    ),
    tap(() => {
      const element = createCustomElement(AppComponent, { injector });
      if (!customElements.get('everymatrix-mm-verification-report')) {
        customElements.define('everymatrix-mm-verification-report', element);
      }

      patchDomHandlerGetScrollableParents();
    })
  );
}
